import {Component, Input} from '@angular/core';
import {OrdersSuccessData} from "../../../../interfaces/orders-success-data";

@Component({
  selector: 'app-message-delivery-np-confirm',
  templateUrl: './message-delivery-np-confirm.component.html',
  styleUrls: ['./message-delivery-np-confirm.component.scss']
})
export class MessageDeliveryNPConfirmComponent {
  @Input() sumAfterPay;

  public data: OrdersSuccessData;

  public isDeliveryNPConfirmation: boolean = false;
  deliveryNPConfirmationShow(data: OrdersSuccessData) {
    this.data = data;
    this.isDeliveryNPConfirmation = true;
  }

  protected readonly parseFloat = parseFloat;
}
